import React from 'react';
import cx from 'classnames';
import DSRCheckbox from '@salesforce/design-system-react/lib/components/checkbox';

function Toggle({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(DSRCheckbox, Object.assign({}, props, {
    variant: "toggle",
    className: cx(className, "tds-form-element_toggle")
  }));
}
Toggle.displayName = "Toggle";
Toggle.propTypes = DSRCheckbox.propTypes;
Toggle.defaultProps = DSRCheckbox.defaultProps;

export { Toggle as default };
